import { render, staticRenderFns } from "./BranchDataInfo.vue?vue&type=template&id=49b729d6&"
import script from "./BranchDataInfo.vue?vue&type=script&lang=js&"
export * from "./BranchDataInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports